document.addEventListener('DOMContentLoaded', function() {
  // 初始化移动端指示器
  initProductCompareScrollIndicator();
  
  // 初始化PC端指示器
  initPCProductCompareScrollIndicator();
  
  // PC端滚动指示器实现
  function initPCProductCompareScrollIndicator() {
    const compareSections = document.querySelectorAll('.joe-compare-container');
    
    compareSections.forEach(section => {
      const pcSection = section.querySelector('.compare-table-pc');
      if (!pcSection) return;
      
      // 获取相关元素
      const headerContainer = pcSection.querySelector('.compare-table-header');
      const bodyTable = pcSection.querySelector('.compare-table_body');
      const bottomPart = pcSection.querySelector('.pc-sticky-header_bottom');
      const navBar = pcSection.querySelector('.joe-product-compare_nav-bar');
      const navTrack = pcSection.querySelector('.joe-product-compare_nav');
      
      if (!headerContainer || !bodyTable || !bottomPart || !navBar || !navTrack) return;
      
      // 状态变量
      let isScrolling = false;
      let lastScrollTop = 0;
      let ticking = false;
      
      // 计算关键尺寸
      function updateDimensions() {
        return {
          bodyHeight: bodyTable.offsetHeight,
          bodyOffsetTop: bodyTable.getBoundingClientRect().top + window.scrollY,
          viewportHeight: window.innerHeight,
          headerHeight: headerContainer.offsetHeight,
          headerTop: headerContainer.getBoundingClientRect().top,
          bodyTop: bodyTable.getBoundingClientRect().top,
          bodyBottom: bodyTable.getBoundingClientRect().bottom,
          bottomPartHeight: bottomPart.offsetHeight,
          pageScrollY: window.scrollY
        };
      }
      
      // 计算精确的滚动进度比例
      function calculateScrollProgress() {
        const dims = updateDimensions();
        
        // 如果header未固定，进度为0
        if (dims.headerTop > 0) {
          return 0;
        }
        
        // 如果已经滚动超过表格底部，进度为1
        if (dims.bodyBottom <= dims.viewportHeight) {
          return 1;
        }
        
        // 计算可视区域内表格内容已滚动的部分
        const scrolledAmount = dims.pageScrollY - dims.bodyOffsetTop + dims.headerHeight;
        // 计算表格总可滚动高度
        const totalScrollable = dims.bodyHeight - dims.viewportHeight + dims.headerHeight;
        
        // 确保进度在0-1范围内
        return Math.min(1, Math.max(0, scrolledAmount / totalScrollable));
      }
      
      // 动态更新滑块尺寸和位置
      function updateSlider() {
        if (ticking) return;
        
        ticking = true;
        requestAnimationFrame(() => {
          const dims = updateDimensions();
          
          // 1. 计算滑块大小 - 视口占表格总高度的比例
          const viewportRatio = dims.viewportHeight / (dims.bodyHeight + dims.headerHeight);
          const sliderSizeRatio = Math.min(0.8, Math.max(0.1, viewportRatio));
          navBar.style.height = `${sliderSizeRatio * 100}%`;
          
          // 2. 计算滑块位置
          const scrollProgress = calculateScrollProgress();
          
          // 考虑滑块自身高度
          const maxTop = 100 - parseFloat(navBar.style.height);
          navBar.style.top = `${scrollProgress * maxTop}%`;
          
          // 3. 设置滑块可见性
          const headerFixed = dims.headerTop <= 0;
          navTrack.style.opacity = headerFixed ? '1' : '0.5';
          
          ticking = false;
        });
      }
      
      // 滚动事件处理
      function handleScroll() {
        updateSlider();
        
        // 检测滚动开始/结束
        if (!isScrolling) {
          isScrolling = true;
          navBar.style.transition = 'top 0.1s ease-out';
        }
        
        clearTimeout(window.pcScrollEndTimer);
        window.pcScrollEndTimer = setTimeout(() => {
          isScrolling = false;
          navBar.style.transition = 'top 0.3s ease';
          updateSlider(); // 最终位置更新
        }, 100);
        
        lastScrollTop = window.pageYOffset;
      }
      
      // 滑块拖动功能
      function initSliderDrag() {
        let isDragging = false;
        let startY = 0;
        
        navBar.addEventListener('mousedown', startDrag);
        navBar.addEventListener('touchstart', e => {
          startDrag(e.touches[0]);
        }, { passive: true });
        
        function startDrag(e) {
          isDragging = true;
          startY = e.clientY || e.pageY;
          
          // 添加事件监听
          document.addEventListener('mousemove', onDrag);
          document.addEventListener('touchmove', e => onDrag(e.touches[0]), { passive: false });
          document.addEventListener('mouseup', stopDrag);
          document.addEventListener('touchend', stopDrag);
          
          // 改变滑块样式
          navBar.style.transition = 'none';
          navBar.style.backgroundColor = '#5a5d4a';
          navBar.style.width = '6px';
          navBar.classList.add('dragging');
          
          // 防止事件冒泡
          e.stopPropagation && e.stopPropagation();
        }
        
        function onDrag(e) {
          if (!isDragging) return;
          
          const currentY = e.clientY || e.pageY;
          const deltaY = currentY - startY;
          
          // 计算新位置
          const navTrackHeight = navTrack.offsetHeight;
          const navBarHeight = navBar.offsetHeight;
          const currentTop = parseFloat(navBar.style.top) || 0;
          const maxTop = 100 - (navBarHeight / navTrackHeight) * 100;
          
          // 更新滑块位置
          const newTop = Math.max(0, Math.min(maxTop, currentTop + (deltaY / navTrackHeight) * 100));
          navBar.style.top = `${newTop}%`;
          
          // 计算对应的滚动位置
          const dims = updateDimensions();
          const dragProgress = newTop / maxTop;
          
          // 计算目标滚动位置
          const totalScrollable = dims.bodyHeight - dims.viewportHeight + dims.headerHeight;
          const targetScrollY = dims.bodyOffsetTop - dims.headerHeight + (dragProgress * totalScrollable);
          
          // 滚动页面
          window.scrollTo({
            top: targetScrollY,
            behavior: 'auto'
          });
          
          startY = currentY;
          
          // 防止默认行为
          e.preventDefault && e.preventDefault();
        }
        
        function stopDrag(e) {
          if (!isDragging) return;
          
          isDragging = false;
          document.removeEventListener('mousemove', onDrag);
          document.removeEventListener('touchmove', onDrag);
          document.removeEventListener('mouseup', stopDrag);
          document.removeEventListener('touchend', stopDrag);
          
          // 恢复滑块样式
          navBar.style.transition = 'top 0.3s ease';
          navBar.style.backgroundColor = '#696c58';
          navBar.style.width = '100%';
          navBar.classList.remove('dragging');
        }
      }
      
      // 初始化事件监听
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', () => {
        updateSlider();
      }, { passive: true });
      
      // 图片加载后重新计算
      if (typeof document.addEventListener === 'function') {
        document.addEventListener('lazyloaded', updateSlider);
      }
      
      // 启用滑块拖动
      initSliderDrag();
      
      // 首次更新
      setTimeout(updateSlider, 100);
    });
  }
  
  // 移动端滚动指示器实现 (原有函数保持不变)
  function initProductCompareScrollIndicator() {
    const compareSections = document.querySelectorAll('.joe-compare-container');
    
    compareSections.forEach(section => {
      const mobileSection = section.querySelector('.compare-mobile');
      if (!mobileSection) return;
      
      // 获取相关元素
      const stickyHeader = mobileSection.querySelector('.mobile-sticky-header');
      const stickyContainer = stickyHeader.querySelector('.mobile-sticky-header_container');
      const bottomPart = stickyHeader.querySelector('.mobile-sticky-header_bottom');
      const contentContainer = mobileSection.querySelector('.mobile-two-column');
      const navBar = mobileSection.querySelector('.joe-product-compare_nav-bar');
      const navTrack = mobileSection.querySelector('.joe-product-compare_nav');
      
      if (!stickyHeader || !contentContainer || !navBar || !navTrack) return;
      
      // 状态变量
      let isScrolling = false;
      let lastScrollTop = 0;
      let ticking = false;
      
      // 计算关键尺寸
      function updateDimensions() {
        return {
          contentHeight: contentContainer.scrollHeight,
          contentOffsetTop: contentContainer.offsetTop,
          viewportHeight: window.innerHeight,
          headerHeight: stickyContainer.offsetHeight,
          headerTop: stickyHeader.getBoundingClientRect().top,
          contentTop: contentContainer.getBoundingClientRect().top,
          contentBottom: contentContainer.getBoundingClientRect().bottom,
          bottomPartHeight: bottomPart.offsetHeight
        };
      }
      
      // 计算精确的滚动进度比例
      function calculateScrollProgress() {
        const dims = updateDimensions();
        
        // 如果header未固定，进度为0
        if (dims.headerTop > 0) {
          return 0;
        }
        
        // 计算header底部相对于content的位置
        const headerBottom = dims.headerHeight;
        const contentVisibleStart = Math.max(0, headerBottom - dims.contentTop);
        
        // 计算内容总高度
        const totalContentHeight = dims.contentHeight;
        
        // 计算可见高度与总高度的比例
        if (contentVisibleStart <= 0) {
          // 内容顶部尚未被覆盖
          return 0;
        } else if (contentVisibleStart >= totalContentHeight - dims.bottomPartHeight) {
          // 内容几乎全部被覆盖
          return 1;
        } else {
          // 正常滚动范围内 - 使用更精确的公式
          return Math.min(1, Math.max(0, 
            contentVisibleStart / (totalContentHeight - dims.bottomPartHeight)
          ));
        }
      }
      
      // 动态更新滑块尺寸和位置
      function updateSlider() {
        if (ticking) return;
        
        ticking = true;
        requestAnimationFrame(() => {
          const dims = updateDimensions();
          
          // 1. 计算滑块大小
          const viewableHeight = dims.viewportHeight - dims.headerHeight;
          const sliderSizeRatio = Math.min(0.8, Math.max(0.1, viewableHeight / dims.contentHeight));
          navBar.style.height = `${sliderSizeRatio * 100}%`;
          
          // 2. 计算滑块位置
          const scrollProgress = calculateScrollProgress();
          
          // 考虑滑块自身高度
          const maxTop = 100 - parseFloat(navBar.style.height);
          navBar.style.top = `${scrollProgress * maxTop}%`;
          
          // 3. 设置滑块可见性
          const headerFixed = dims.headerTop <= 0;
          navTrack.style.opacity = headerFixed ? '1' : '0.5';
          
          ticking = false;
        });
      }
      
      // 滚动事件处理
      function handleScroll() {
        updateSlider();
        
        // 检测滚动开始/结束
        if (!isScrolling) {
          isScrolling = true;
          navBar.style.transition = 'top 0.1s ease-out';
        }
        
        clearTimeout(window.scrollEndTimer);
        window.scrollEndTimer = setTimeout(() => {
          isScrolling = false;
          navBar.style.transition = 'top 0.3s ease';
          updateSlider(); // 最终位置更新
        }, 100);
        
        lastScrollTop = window.pageYOffset;
      }
      
      // 滑块拖动功能
      function initSliderDrag() {
        let isDragging = false;
        let startY = 0;
        
        navBar.addEventListener('mousedown', startDrag);
        navBar.addEventListener('touchstart', e => {
          startDrag(e.touches[0]);
        }, { passive: true });
        
        function startDrag(e) {
          isDragging = true;
          startY = e.clientY || e.pageY;
          
          // 添加事件监听
          document.addEventListener('mousemove', onDrag);
          document.addEventListener('touchmove', e => onDrag(e.touches[0]), { passive: false });
          document.addEventListener('mouseup', stopDrag);
          document.addEventListener('touchend', stopDrag);
          
          // 改变滑块样式
          navBar.style.transition = 'none';
          navBar.style.backgroundColor = '#5a5d4a';
          navBar.style.width = '6px';
          navBar.classList.add('dragging');
          
          // 防止事件冒泡
          e.stopPropagation && e.stopPropagation();
        }
        
        function onDrag(e) {
          if (!isDragging) return;
          
          const currentY = e.clientY || e.pageY;
          const deltaY = currentY - startY;
          
          // 计算新位置
          const navTrackHeight = navTrack.offsetHeight;
          const navBarHeight = navBar.offsetHeight;
          const currentTop = parseFloat(navBar.style.top) || 0;
          const maxTop = 100 - (navBarHeight / navTrackHeight) * 100;
          
          // 更新滑块位置
          const newTop = Math.max(0, Math.min(maxTop, currentTop + (deltaY / navTrackHeight) * 100));
          navBar.style.top = `${newTop}%`;
          
          // 计算对应的文档滚动位置
          const dims = updateDimensions();
          const dragProgress = newTop / maxTop;
          
          // 使用逆向计算 - 从滑块位置计算应该滚动到的位置
          const targetContentVisibleStart = dragProgress * (dims.contentHeight - dims.bottomPartHeight);
          const targetScrollY = dims.contentOffsetTop + targetContentVisibleStart - dims.headerHeight;
          
          // 滚动页面
          window.scrollTo({
            top: targetScrollY,
            behavior: 'auto'
          });
          
          startY = currentY;
          
          // 防止默认行为
          e.preventDefault && e.preventDefault();
        }
        
        function stopDrag(e) {
          if (!isDragging) return;
          
          isDragging = false;
          document.removeEventListener('mousemove', onDrag);
          document.removeEventListener('touchmove', onDrag);
          document.removeEventListener('mouseup', stopDrag);
          document.removeEventListener('touchend', stopDrag);
          
          // 恢复滑块样式
          navBar.style.transition = 'top 0.3s ease';
          navBar.style.backgroundColor = '#696c58';
          navBar.style.width = '100%';
          navBar.classList.remove('dragging');
        }
      }
      
      // 初始化事件监听
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', () => {
        updateSlider();
      }, { passive: true });
      
      // 图片加载后重新计算
      if (typeof document.addEventListener === 'function') {
        document.addEventListener('lazyloaded', updateSlider);
      }
      
      // 启用滑块拖动
      initSliderDrag();
      
      // 首次更新
      setTimeout(updateSlider, 100);
    });
  }
});